import { apiCall } from "./apiCall";

export default function stockApi() {
  return {
    getStockAvailable: (data, token) =>
      apiCall("/getStockAvailable", data, token),
    transferStock: (data, token) => apiCall("/transferStock", data, token),
    getStockTransferList: (data, token) =>
      apiCall("/getStockTransferList", data, token),
    revertStockTransfer: (data, token) =>
      apiCall("/revertStockTransfer", data, token),
  };
}
